<script setup>
import LeadsTable from '@/Pages/Dashboard/Partner/Leads/Partials/LeadsTable.vue';
import { computed } from 'vue';
import ConvertCustomerNotification from '@/Pages/Dashboard/Partner/Leads/Partials/ConvertCustomerNotification.vue';

const props = defineProps({
  tickets: {
    type: Object,
    required: true,
  },
  filters: {
    type: Object,
    default: () => ({}),
  },
  convertedCustomer: {
    type: String,
    default: null,
  },
});
const pagination = computed(() => {
  const { data, ...rest } = props.tickets;

  return rest;
});
</script>

<script>
import DashboardLayout from '@/Layouts/DashboardLayout.vue';

export default {
  layout: DashboardLayout,
};
</script>

<template>
  <div class="bg-white py-5">
    <div class="container">
      <convert-customer-notification :user="convertedCustomer" />
      <leads-table :leads="tickets.data" :pagination="pagination" :filters="filters"></leads-table>
    </div>
  </div>
</template>
